import { isMeituanAppOrWebview } from '@nibfe/mkt-env-api';
import { getSystemInfoSync } from '@max/meituan-uni-system';
const isMtAPP = isMeituanAppOrWebview();
export const evokeMtAappUrl = url => {
    const MTH5Url = 'https://w.dianping.com/cube/evoke/meituan.html?url=';
    return isMtAPP ? url : `${MTH5Url}${encodeURIComponent(url)}`;
};
export const handleParams = (params = {}) => {
    return Object.keys(params ?? {}).map(key => {
        const value = params[key];
        return value ? `&${key}=${value}` : '';
    }).join('');
};
// 适配折叠屏宽度
export const adaptScreenWidth = () => {
    try {
        const systemInfo = getSystemInfoSync();
        const screenWidth = systemInfo?.screenWidth;
        if (!screenWidth) {
            return '342rpx';
        }
        else if (screenWidth > 360) {
            return '342rpx';
        }
        else if (screenWidth < 360) {
            return `${Math.floor(screenWidth / 357 * 320)}rpx`;
        }
        else {
            return '342rpx';
        }
    }
    catch (e) {
        return '342rpx';
    }
};
